<template>
  <div class="sale">
    <h2 class="normal">审核信息</h2>
    <div
      v-if="
        queryType !== '入驻审核' &&
        queryType !== '中介审核' &&
        queryType !== '头像审核'
      "
      class="userApllyList list"
    >
      <div>
        <div class="userAplly item">用户</div>
        <div
          v-for="(apply, index) in userApplyList"
          :key="apply.id"
          @click="toCheck((clickIndex = index))"
          class="userAplly item"
        >
          {{ index + 1 }}
        </div>
      </div>
    </div>

    <div v-if="queryType === '聊天举报'">
      <el-select
        v-model="jubao"
        placeholder="全部"
        style="margin: 20px 0; width: 200px"
      >
        <el-option
          v-for="way in ['全部', '举报用户', '举报销售']"
          :key="way"
          :label="way"
          :value="way"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="changeWay">筛选</el-button>
    </div>
    <div v-if="queryType === 'APP反馈'">
      <div v-if="feedback">
        <div>反馈人昵称：{{ this.item.nickname }}</div>
        <div>
          反馈人头像：<br /><img :src="item.avatar" mode="scaleToFill" />
        </div>
        <div>反馈信息： {{ this.item.words }}</div>
        <div>
          反馈图片：<br /><img :src="item.images" class="feedbackImage" />
        </div>
        <div>
          <el-input v-model="reply_words" style="width: 200px"></el-input>
        </div>
        <div>
          <el-button type="primary" @click="setfeedback('拒绝')"
            >拒绝</el-button
          >
          <el-button type="primary" @click="setfeedback('通过')"
            >同意</el-button
          >
        </div>
      </div>
    </div>

    <div v-if="queryType === 'APP进群审核'">
      <div v-if="currentCheck.check_details">
        <div v-if="currentCheck.user" class="normal">
          申请人：{{ currentCheck.user.nickname }}
        </div>
        <div v-if="currentCheck.name" class="normal">
          群名：{{ currentCheck.name }}
        </div>
        <div v-if="currentCheck.check_details.academy" class="normal">
          院校：{{ currentCheck.check_details.academy }}
        </div>
        <div v-if="currentCheck.check_details.major" class="normal">
          专业：{{ currentCheck.check_details.major }}
        </div>
        <div v-if="currentCheck.check_details.grade" class="normal">
          入学年份：{{ currentCheck.check_details.grade }}
        </div>
        <div v-if="currentCheck.check_details.id_card" class="normal">
          <div>校园卡</div>
          <img
            :src="currentCheck.check_details.id_card"
            preview="0"
            preview-text="校园卡"
            alt="加载失败"
          />
        </div>

        <div v-if="currentCheck.check_details.Building" class="normal">
          楼号：{{ currentCheck.check_details.Building }}
        </div>
        <div v-if="currentCheck.check_details.unit" class="normal">
          单元：{{ currentCheck.check_details.unit }}
        </div>
        <div v-if="currentCheck.check_details.roomNum" class="normal">
          房号：{{ currentCheck.check_details.roomNum }}
        </div>
        <div v-if="currentCheck.check_details.apply_img" class="normal">
          <div>房产证</div>
          <img
            :src="currentCheck.check_details.apply_img"
            preview="0"
            preview-text="房产证"
            alt="加载失败"
          />
        </div>

        <div class="normal">
          <button @click="dealGroupApply('PASS')">同意</button>
          <button @click="dealGroupApply('REFUSE')">拒绝</button>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === 'APP建群审核'">
      <div v-if="currentCheck.check_details">
        <div v-if="currentCheck.user" class="normal">
          申请人：{{ currentCheck.user.nickname }}
        </div>
        <div v-if="currentCheck.check_details.type" class="normal">
          群类别：{{ currentCheck.check_details.type }}
        </div>
        <div v-if="currentCheck.check_details.name" class="normal">
          新建群名：{{ currentCheck.check_details.name }}
        </div>
        <div v-if="currentCheck.check_details.tip" class="normal">
          小群标签：{{ currentCheck.check_details.tip }}
        </div>
        <div v-if="currentCheck.check_details.chat_id" class="normal">
          绑定的大群名：{{ currentCheck.bigName }}
        </div>
        <div>
          提示
          <input type="text" v-model="refuse_reason" />
        </div>
        <div class="normal">
          <button @click="dealCreateApply('PASS')">通过</button>
          <button @click="dealCreateApply('REFUSE')">拒绝</button>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === 'APP举报审核'">
      <div>
        <div v-if="currentCheck.report_name" class="normal">
          举报人：{{ currentCheck.report_name }}
        </div>
        <div v-if="currentCheck.nickname" class="normal">
          被举报人：{{ currentCheck.nickname }}
        </div>
        <div v-if="currentCheck.talk" class="normal">
          被举报消息：{{ currentCheck.talk.content }}
        </div>
        <div v-if="currentCheck.name" class="normal">
          群名：{{ currentCheck.name }}
        </div>
        <div v-if="currentCheck.chat_id">
          <div class="normal">
            对被举报者：
            <button
              @click="
                unAppclock('拉黑', currentCheck.to_user, currentCheck.nickname)
              "
            >
              拉黑
            </button>
            <button
              @click="
                unAppclock('解禁', currentCheck.to_user, currentCheck.nickname)
              "
            >
              解禁
            </button>
          </div>
          <div class="normal">
            对举报者：
            <button
              @click="
                unAppclock(
                  '拉黑',
                  currentCheck.user_id,
                  currentCheck.report_name
                )
              "
            >
              拉黑
            </button>
          </div>
          <div class="normal">
            对举报记录：
            <button @click="shenhe(currentCheck.id)">标为已审核</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === 'APP申诉'">
      <div>
        <div v-if="currentCheck.nickname" class="normal">
          申诉人：{{ currentCheck.nickname }}
        </div>
        <div v-if="currentCheck.name" class="normal">
          群名：{{ currentCheck.name }}
        </div>
        <div v-if="currentCheck.chat_id">
          <div class="normal">
            对申诉人：
            <button
              @click="
                unAppclock('解禁', currentCheck.user_id, currentCheck.nickname)
              "
            >
              解禁
            </button>
          </div>
          <div class="normal">
            对举报记录：
            <button @click="shenhe(currentCheck.id)">标为已审核</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === '群聊申诉'">
      <div>
        <div v-if="currentCheck.user_name" class="normal">
          申诉人昵称：{{ currentCheck.user_name }}
        </div>
        <div v-if="currentCheck.head_url" class="normal">
          <img :src="currentCheck.head_url" alt="" />
        </div>
        <div v-if="currentCheck.user_name" class="normal">
          申诉人身份：{{ currentCheck.user_type || "普通用户" }}
        </div>
        <div v-if="currentCheck.user_name" class="normal">
          申诉人状态：{{ currentCheck.user_status || "正常" }}
        </div>
        <div v-if="currentCheck.name" class="normal">
          群名：{{ currentCheck.name }}
        </div>
        <div class="normal" v-if="currentCheck.rlist">
          拦截消息
          <div v-for="(item, index) in currentCheck.rlist" :key="index">
            <img
              v-if="item.talk_id.includes('aliyuncs')"
              :src="item.talk_id"
              preview="1"
            />
            <span v-else>{{ item.talk_id }}</span>
            <span>{{ item.create_time }}</span>
          </div>
        </div>
        <div v-if="currentCheck.rlist">
          <div class="normal">
            对申诉人：
            <button
              @click="
                unclock(
                  '解禁',
                  currentCheck.user_id,
                  currentCheck.user_name,
                  currentCheck.id
                )
              "
            >
              解禁
            </button>
          </div>
          <div class="normal">
            对举报记录：
            <button @click="shenhe(currentCheck.id)">标为已审核</button>
          </div>
          <div class="normal">
            对举报记录：
            <button @click="shenhe(currentCheck.id, '驳回')">不让再申诉</button>
          </div>
        </div>
        <div class="normal" v-if="currentCheck.ulist">
          最近消息
          <div v-for="(item, index) in currentCheck.ulist" :key="index">
            <img
              v-if="item.content.includes('aliyuncs')"
              :src="item.content"
              preview="1"
            />
            <span v-else>{{ item.content }}</span>
            <span>{{ item.create_time }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === '房源审核'">
      <div v-if="currentCheck.check_details">
        <div v-if="currentCheck.user_name" class="normal">
          经纪人：{{ currentCheck.user_name }}
        </div>
        <div v-if="currentCheck.check_details.name" class="normal">
          房源：{{ currentCheck.check_details.name }}
        </div>
        <div v-if="currentCheck.check_details.number" class="normal">
          房源编号：{{ currentCheck.check_details.number }}
        </div>
        <div v-if="currentCheck.check_details.hang_price" class="normal">
          总价：{{ currentCheck.check_details.hang_price }}
        </div>
        <div v-if="currentCheck.check_details.purpose" class="normal">
          类别：{{ currentCheck.check_details.purpose }}
        </div>
        <div v-if="currentCheck.check_details.layout" class="normal">
          户型：{{ currentCheck.check_details.layout }}
        </div>
        <div v-if="currentCheck.check_details.square" class="normal">
          面积：{{ currentCheck.check_details.square }}
        </div>
        <div v-if="currentCheck.check_details.trim" class="normal">
          装修：{{ currentCheck.check_details.trim }}
        </div>
        <div v-if="currentCheck.check_details.floor" class="normal">
          楼层：{{ currentCheck.check_details.floor }}
        </div>
        <div>
          提示
          <input type="text" v-model="refuse_reason" />
        </div>
        <div class="normal">
          <button @click="addHang()">通过</button>
          <button @click="refuse">拒绝</button>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === '专家入驻'">
      <div v-if="currentCheck.check_details">
        <div v-if="currentCheck.check_details.user_name" class="normal">
          姓名：{{ currentCheck.check_details.user_name }}
        </div>
        <div v-if="currentCheck.check_details.phone" class="normal">
          电话：{{ currentCheck.check_details.phone }}
        </div>
        <div v-if="currentCheck.check_details.Sub_QR" class="normal">
          <div>公众号二维码</div>
          <img
            :src="currentCheck.check_details.Sub_QR"
            preview="0"
            preview-text="公众号二维码"
            alt="加载失败"
          />
        </div>
        <div v-if="currentCheck.check_details.Sub_name" class="normal">
          公众号名：{{ currentCheck.check_details.Sub_name }}
        </div>
        <div v-if="currentCheck.check_details.Tiktok_QR" class="normal">
          <div>视频号或抖音二维码</div>
          <img
            :src="currentCheck.check_details.Tiktok_QR"
            preview="0"
            preview-text="视频号或抖音二维码"
            alt="加载失败"
          />
        </div>
        <div v-if="currentCheck.check_details.Tiktok_Num" class="normal">
          视频号或抖音名：{{ currentCheck.check_details.Tiktok_Num }}
        </div>
        <div v-if="currentCheck.check_details.Group_QR" class="normal">
          <div>购房微信群二维码</div>
          <img
            :src="currentCheck.check_details.Group_QR"
            preview="0"
            preview-text="购房微信群二维码"
            alt="加载失败"
          />
        </div>
        <div v-if="currentCheck.check_details.Group_Name" class="normal">
          购房微信群名：{{ currentCheck.check_details.Group_Name }}
        </div>
        <div v-if="currentCheck.check_details.describe" class="normal">
          描述：{{ currentCheck.check_details.describe }}
        </div>
        <div v-if="currentCheck.check_details.field" class="normal">
          擅长：{{ currentCheck.check_details.field }}
        </div>
        <div v-if="currentCheck.check_details.district" class="normal">
          区域：{{ currentCheck.check_details.district }}
        </div>
        <div v-if="currentCheck.check_details.idCard" class="normal">
          <div>身份证正面</div>
          <img
            :src="currentCheck.check_details.idCard"
            preview="0"
            preview-text="身份证正面"
            alt="加载失败"
          />
        </div>
        <div v-if="currentCheck.check_details.idCard2" class="normal">
          <div>身份证反面</div>
          <img
            :src="currentCheck.check_details.idCard2"
            preview="0"
            preview-text="身份证反面"
            alt="加载失败"
          />
        </div>
        <div>
          提示
          <input type="text" v-model="refuse_reason" />
        </div>
        <div class="normal">
          <button @click="expert()">通过</button>
          <button @click="refuse">拒绝</button>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === '业主群审核'">
      <div v-if="currentCheck.check_details">
        <div v-if="currentCheck.chat_name" class="normal">
          业主群：{{ currentCheck.chat_name }}
        </div>
        <div v-if="currentCheck.user_name" class="normal">
          姓名：{{ currentCheck.user_name }}
        </div>
        <div v-if="currentCheck.user_type" class="normal">
          身份：{{ currentCheck.user_type }}
        </div>
        <div v-if="currentCheck.check_details.Building" class="normal">
          楼栋：{{ currentCheck.check_details.Building }}
        </div>
        <div v-if="currentCheck.check_details.unit" class="normal">
          单元：{{ currentCheck.check_details.unit }}
        </div>
        <div v-if="currentCheck.check_details.roomNum" class="normal">
          房间号：{{ currentCheck.check_details.roomNum }}
        </div>
        <div v-if="currentCheck.check_details.apply_img" class="normal">
          <div>合同</div>
          <div
            v-for="(img, index) in currentCheck.check_details.apply_img"
            :key="index"
          >
            <el-image
              :src="img"
              alt="加载失败"
              :preview-src-list="[img]"
              fit="contain"
            >
            </el-image>
          </div>
        </div>
        <div>
          提示
          <input type="text" v-model="refuse_reason" />
        </div>
        <div class="normal">
          <button @click="dealApply('PASS')">通过</button>
          <button @click="dealApply('REFUSE')">拒绝</button>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === '举报审核' || queryType === '聊天举报'">
      <div
        v-if="currentCheck && (currentCheck.report_id || currentCheck.chat_id)"
      >
        <div v-if="currentCheck.create_time" class="normal">
          时间：{{ currentCheck.create_time }}
        </div>
        <div v-if="currentCheck.user_name" class="normal">
          举报人：{{ currentCheck.user_name }}({{
            "身份：" + currentCheck.user_type
          }})
        </div>
        <div v-if="currentCheck.report_name" class="normal">
          被举报人：{{ currentCheck.report_name }}({{
            "身份：" + currentCheck.report_type
          }})
        </div>
        <div class="normal">被举报人状态：{{ currentCheck.report_status }}</div>

        <div v-if="currentCheck.hang_name" class="normal">
          调价房源：{{ currentCheck.hang_name }}
        </div>
        <div v-if="currentCheck.after" class="normal">
          调价价格：{{ currentCheck.after }}
        </div>

        <div v-if="currentCheck.chat_name" class="normal">
          群聊房间：{{ currentCheck.chat_name }}
        </div>

        <div v-if="currentCheck.words" class="normal">
          举报{{ currentCheck.chat_id ? "消息" : "理由" }}：{{
            currentCheck.words
          }}
        </div>
        <div v-if="currentCheck.putImg" class="normal">
          <div>图片</div>
          <img
            :src="currentCheck.putImg"
            preview="0"
            preview-text="图片"
            alt="加载失败"
          />
        </div>
        <div v-if="currentCheck.chat_id">
          <div class="normal">
            对被举报者：
            <button @click="punishUser('禁言', currentCheck)">禁言</button>
            <button @click="punishUser('软隐藏', currentCheck)">软隐藏</button>
            <button
              @click="
                unclock('拉黑', currentCheck.to_user, currentCheck.report_name)
              "
            >
              拉黑
            </button>
            <button
              @click="
                unclock('解禁', currentCheck.to_user, currentCheck.report_name)
              "
            >
              解禁
            </button>
          </div>
          <div class="normal">
            对举报者：
            <button
              @click="
                unclock('拉黑', currentCheck.user_id, currentCheck.user_name)
              "
            >
              拉黑
            </button>
          </div>
          <div class="normal">
            对举报记录：
            <button @click="shenhe(currentCheck.id)">标为已审核</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === '拿证审核'">
      <div v-if="currentCheck.check_details">
        <div v-if="currentCheck.user" class="normal">
          顾问：{{ currentCheck.user.user_name }}
        </div>
        <div v-if="currentCheck.real_estate_name" class="normal">
          楼盘：{{ currentCheck.real_estate_name }}
        </div>
        <div class="normal" v-if="currentCheck.check_details.date">
          拿证：{{ currentCheck.check_details.date.advance }}
        </div>
        <div
          v-if="currentCheck.check_details.piece"
          class="normal"
          style="display: flex; justify-content: center"
        >
          <div>价格：</div>
          <div
            v-for="(p, index) in currentCheck.check_details.piece"
            :key="index"
          >
            {{ p.type }}{{ p.price }}&emsp;
          </div>
        </div>
        <div class="normal">
          楼栋：{{ currentCheck.check_details.info.building }}
        </div>
        <div class="normal">
          面积：{{ currentCheck.check_details.info.square }}
        </div>
        <div class="normal">
          装修：{{ currentCheck.check_details.info.trim }}
        </div>
        <div class="normal">
          套数：{{ currentCheck.check_details.rate.house_total }}
        </div>
        <div>
          提示
          <input type="text" v-model="refuse_reason" />
        </div>
        <div class="normal">
          <button @click="dealNZ('PASS')">通过</button>
          <button @click="dealNZ('REFUSE')">拒绝</button>
        </div>
      </div>
    </div>
    <div v-else-if="queryType === '销售大群审核'">
      <div v-if="currentCheck.user">
        <div class="normal">申请人：{{ currentCheck.user.user_name }}</div>
        <div v-if="currentCheck.type" class="normal">
          群类别：{{ currentCheck.type }}
        </div>
        <div v-if="currentCheck.real_estate_name" class="normal">
          绑定楼盘：{{ currentCheck.real_estate_name }}
        </div>
        <div>
          提示
          <input type="text" v-model="refuse_reason" />
        </div>
        <div class="normal">
          <button @click="dealxsApply('PASS')">通过</button>
          <button @click="dealxsApply('REFUSE')">拒绝</button>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- 审核销售顾问入驻 -->
      <!-- <div v-if="currentCheck.check_details && !currentCheck.real_estate_id" class="check">
        <div class="normal">
          <div>申请时间</div>
          <div>{{currentCheck.create_time}}</div>
        </div>
        <div v-if="currentCheck.check_details.idCard" class="normal">
          <div>身份证</div>
          <img :src="currentCheck.check_details.idCard" preview="0" preview-text="身份证" alt="加载失败">
        </div>
        <div v-if="currentCheck.check_details.card" class="normal">
          <div>名片或者工号牌</div>
          <img :src="currentCheck.check_details.card" preview="0" preview-text="名片或工号牌" alt="加载失败">
        </div>
        <div v-if="currentCheck.check_details.congye_QR" class="normal">
          <div>从业二维码</div>
          <img :src="currentCheck.check_details.congye_QR" preview="0" preview-text="身份证" alt="加载失败">
        </div>
        <div class="normal">要绑定的楼盘：<input type="text" v-model="currentCheck.check_details.real_estates"
            @input="onRealNameInput" @blur="onRealNameBlur" @focus="onRealNameFocus">
            <el-tag v-if="noReal">暂无此楼盘</el-tag>
          <div v-if="matchList.length>0">
            <div v-for="(item,index) in matchList" :key="item.id" @mousedown="chooseRealName(index)">
              {{item.real_estate_name}}</div>
          </div>
        </div>
        <div v-if="currentCheck.check_details.user_name" class="normal">姓名：<input type="text" v-model="currentCheck.check_details.user_name"></div>
        <div v-if="currentCheck.check_details.avatar" class="normal">
          <div>头像</div>
          <img :src="currentCheck.check_details.avatar.replace('_mini.jpg','')" preview="0" preview-text="头像" alt="加载失败">
        </div>
        <div v-else-if="currentCheck.check_details.head_url" class="normal">
          <div>头像</div>
          <img :src="currentCheck.check_details.head_url.replace('_mini.jpg','')" preview="0" preview-text="头像" alt="加载失败">
        </div>
        <div v-else class="normal">
          <div>头像</div>
          <img :src="currentCheck.head_url.replace('_mini.jpg','')" preview="0" preview-text="头像" alt="加载失败">
        </div>
        <div v-if="currentCheck.check_details.phone" class="normal">电话：{{currentCheck.check_details.phone}}</div>
        <div v-if="currentCheck.check_details.weChat_num" class="normal">微信号：{{currentCheck.check_details.weChat_num}}</div>
        <div v-if="currentCheck.check_details.setupName" class="normal">机构：{{currentCheck.check_details.setupName}}</div>
        <div v-if="currentCheck.check_details.employee_num" class="normal">从业人员编号：{{currentCheck.check_details.employee_num}}</div>
        <div v-if="currentCheck.check_details.describe" class="normal">描述：{{currentCheck.check_details.describe}}</div>
        <div v-if="currentCheck.check_details.field" class="normal">擅长：{{currentCheck.check_details.field}}</div>
        <div v-if="currentCheck.check_details.weChat_QR" class="normal">
          <div>二维码</div>
          <img :src="currentCheck.check_details.weChat_QR" preview="0" preview-text="二维码" alt="加载失败">
        </div>
        <div>提示
          <input type="text" v-model="refuse_reason">
        </div>
        <div class="normal">
          <button @click="pass('user')">通过</button>
          <button @click="refuse">拒绝</button>
          <button @click="ignore">忽略</button>
        </div>
      </div> -->
      <!-- 审核销售顾问入驻 -->
      <button
        v-if="startCopy"
        @click="
          () => {
            startCopy = !startCopy;
          }
        "
      >
        开始复制
      </button>
      <button
        v-if="!startCopy"
        @click="
          () => {
            startCopy = !startCopy;
          }
        "
      >
        取消复制
      </button>
      <div v-if="queryType == '入驻审核'">
        <el-radio-group v-model="checkRadio" @change="switchStatus">
          <el-radio :label="0">待审核</el-radio>
          <el-radio :label="1">已拒绝</el-radio>
          <el-radio :label="2">已通过</el-radio>
        </el-radio-group>
      </div>

      <el-table
        :key="tableKey"
        fit
        :data="userApplyList"
        :cell-style="setStyle"
        :height="dataHeight + 'px'"
      >
        <el-table-column
          v-if="startCopy"
          sortable
          type="index"
          label="序号"
          prop=""
        ></el-table-column>
        <el-table-column
          v-if="startCopy"
          sortable
          label="申请时间"
          prop="create_time"
        ></el-table-column>
        <el-table-column
          v-if="startCopy && checkRadio == 1"
          label="拒绝时间"
          prop="update_time"
        ></el-table-column>
        <el-table-column
          v-if="startCopy && checkRadio == 2"
          label="通过时间"
          prop="update_time"
        ></el-table-column>
        <el-table-column v-if="startCopy" label="身份证" prop="">
          <template slot-scope="{ row }">
            <div v-if="row.check_details.idCard">
              <el-image
                :src="row.check_details.idCard"
                alt=""
                :preview-src-list="[row.check_details.idCard]"
                fit="contain"
              >
              </el-image>
            </div>
            <div v-else>暂无身份证图片</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="startCopy"
          label="名片或者工号牌"
          prop="create_time"
        >
          <template slot-scope="{ row }">
            <div v-if="row.check_details.card">
              <el-image
                :src="row.check_details.card"
                alt=""
                :preview-src-list="[row.check_details.card]"
                fit="contain"
              >
              </el-image>
            </div>
            <div v-else>名片或者工号牌</div>
          </template>
        </el-table-column>
        <el-table-column v-if="startCopy" label="头像" prop="create_time">
          <template slot-scope="{ row }">
            <div v-if="row.check_details.avatar">
              <el-image
                :src="row.check_details.avatar.replace('_mini.jpg', '')"
                alt=""
                :preview-src-list="[
                  row.check_details.avatar.replace('_mini.jpg', ''),
                ]"
                fit="contain"
              >
              </el-image>
            </div>
            <div v-else-if="row.check_details.head_url">
              <el-image
                :src="row.check_details.head_url.replace('_mini.jpg', '')"
                alt=""
                :preview-src-list="[
                  row.check_details.head_url.replace('_mini.jpg', ''),
                ]"
                fit="contain"
              >
              </el-image>
            </div>
            <div v-else-if="row.head_url">
              <el-image
                :src="row.head_url"
                alt=""
                :preview-src-list="[row.head_url]"
                fit="contain"
              >
              </el-image>
            </div>
            <div v-else>暂无头像</div>
          </template>
        </el-table-column>
        <el-table-column v-if="startCopy" label="电话" prop="">
          <template slot-scope="{ row }">
            <div>{{ row.check_details.phone }}</div>
          </template>
        </el-table-column>
        <el-table-column v-if="startCopy" label="微信号" prop="">
          <template slot-scope="{ row }">
            <div :oncopy="() => false">{{ row.check_details.weChat_num }}</div>
          </template>
        </el-table-column>

        <el-table-column v-if="startCopy" label="二维码" prop="create_time">
          <template slot-scope="{ row }">
            <div v-if="row.check_details.weChat_QR">
              <el-image
                :src="row.check_details.weChat_QR"
                alt=""
                :preview-src-list="[row.check_details.weChat_QR]"
                fit="contain"
              >
              </el-image>
            </div>
            <div v-else>暂无二维码</div>
          </template>
        </el-table-column>
        <el-table-column v-if="startCopy" label="口号">
          <template slot-scope="{ row }">
            <span>{{ row.check_details.brief || "暂无口号" }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="startCopy && checkRadio == 0" label="顾问状态">
          <template slot-scope="{ row }">
            <span>{{ row.is_new ? "新顾问" : "老顾问" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="startCopy && (checkRadio == 1 || checkRadio == 2)"
          label="审核人"
          prop="check_name"
        >
        </el-table-column>
        <!-- <el-table-column sortable label="机构" prop="create_time">
              <template slot-scope="{row}"> 
                <div v-if="row.check_details.setupName">{{row.check_details.setupName}}
                </div>
                <div v-else>
                  暂无机构
                </div>
              </template>
        </el-table-column>
        <el-table-column sortable label="从业编码" prop="create_time">
          <template slot-scope="{row}"> 
            <div v-if="row.check_details.employee_num">{{row.check_details.employee_num}}
            </div>
            <div v-else>
              暂无从业编码
            </div>
          </template>
        </el-table-column>
        <el-table-column sortable label="描述" prop="create_time">
              <template slot-scope="{row}"> 
                <div v-if="row.check_details.describe">{{row.check_details.describe}}
                </div>
                <div v-else>
                  暂无描述
                </div>
              </template>
        </el-table-column>
        <el-table-column sortable label="擅长" prop="create_time">
              <template slot-scope="{row}"> 
                <div v-if="row.check_details.field">{{row.check_details.field}}
                </div>
                <div v-else>
                  暂无擅长
                </div>
              </template>
        </el-table-column> -->
        <el-table-column v-if="startCopy" label="提示" prop="create_time">
          <template slot-scope="{ row }">
            <div>
              <input style="width: 100px" type="text" v-model="refuse_reason" />
            </div>
          </template>
        </el-table-column>

        <el-table-column
          :width="startCopy ? '110px' : '300px'"
          label="绑定楼盘"
          v-if="startCopy"
        >
          <template slot-scope="{ row }">
            <input
              style="width: 80px"
              type="text"
              v-model="row.check_details.real_estates"
            />
          </template>
        </el-table-column>

        <el-table-column
          :width="startCopy ? '110px' : '300px'"
          label="绑定楼盘"
          v-if="!startCopy"
        >
          <template slot-scope="{ row }">
            {{ row.check_details.real_estates }}
          </template>
        </el-table-column>
        <el-table-column
          :width="startCopy ? '110px' : '300px'"
          label="姓名"
          prop="user_name"
          v-if="startCopy"
        >
          <template slot-scope="{ row }">
            <input
              style="width: 80px"
              type="text"
              v-model="row.check_details.user_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          :width="startCopy ? '110px' : '300px'"
          label="姓名"
          prop="user_name"
          v-if="!startCopy"
        >
          <template slot-scope="{ row }">
            <div>{{ row.check_details.user_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="startCopy && checkRadio !== 1 && checkRadio !== 2"
          label="操作"
          prop="create_time"
          min-width="200px"
        >
          <template slot-scope="{ row, $index }">
            <el-button @click="pass('user', $index)">通过</el-button>
            <el-button @click="refuse($index)">拒绝</el-button>
            <el-button @click="ignore($index)">忽略</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startCopy: true,
      item: "",
      reply_words: "",
      feedback: false,
      allApplyList: [],
      userApplyList: [],
      pageSize: 20,
      realApplyList: [],
      currentCheck: {},
      refuse_reason: "",
      tableKey: 1,
      realEstateNameList: [],
      matchList: [],
      real_estate_id: "",
      total: 0,
      wantList: [],
      note: "",
      currentPage: 1,
      noReal: false,
      checkRadio: 0,
      queryType: "",
      city: "",
      modelMap2: {
        杭州: "WpUpdateCheckModel",
        苏州: "SzUpdateCheckModel",
        天津: "TjUpdateCheckModel",
        绍兴: "SxUpdateCheckModel",
        宁波: "NbUpdateCheckModel",
      },
      jubao: "全部",
      dataHeight: 700,
      fromInfo: "",
      clickIndex: 0,
      stylechange: "background-color: #FFA2A2",
    };
  },
  created() {
    this.dataHeight = window.innerHeight - 100;
    console.log(this.dataHeight);
  },
  beforeRouteEnter(to, from, next) {
    if (from.name === "login") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      let origin = this.$options.data();
      Object.assign(this.$data, origin);
      this.init();
    }
    this.$route.meta.isBack = false;
  },
  methods: {
    init() {
      let that = this;
      this.queryType = this.$route.query.from;
      that.fromInfo = this.$route.query.info;
      that.city = that.$store.state.Counter.city;
      if (this.queryType.includes("APP")) {
        that.getGroupList();
        return;
      }
      if (
        [
          "专家入驻",
          "业主群审核",
          "拿证审核",
          "群聊申诉",
          "销售大群审核",
          "头像审核",
        ].includes(this.queryType)
      ) {
        that.queryUpdateConfirm();
        return;
      }
      that.$axios
        .get(that.$url_prefix + "queryRealEstateNameList", {
          params: {
            type: that.queryType,
          },
        })
        .then(function (res) {
          that.realEstateNameList = res.data.data;
          that.queryUpdateConfirm();
        })
        .catch(function (res) {
          console.log(res);
        });
    },
    queryUpdateConfirm() {
      let that = this;
      that.$open();
      that.$axios
        .get(that.$url_prefix + "queryUpdateConfirm", {
          params: {
            type: that.queryType,
            info: that.fromInfo,
          },
        })
        .then(function (res) {
          that.$close();
          console.log("back", res);
          let arr = res.data.data;
          if (arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].key_word !== "latest_news" && arr[i].check_details) {
                arr[i].check_details = JSON.parse(arr[i].check_details);
              }
              if (arr[i].real_estate_id) {
                that.realApplyList.push(arr[i]);
              } else {
                that.userApplyList.push(arr[i]);
              }
            }
          }
          that.allApplyList = JSON.parse(JSON.stringify(that.userApplyList));
          that.$previewRefresh();
        })
        .catch((res) => {
          that.$close();
          console.log("fail", res);
        });
    },
    getGroupList() {
      let that = this;
      that.$axios
        .get(that.$url_prefix + "getGroupList", {
          params: {
            type: that.queryType,
          },
        })
        .then(function (res) {
          console.log("back", res);
          let arr = res.data.data;
          if (arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].check_details) {
                arr[i].check_details = JSON.parse(arr[i].check_details);
              }
              that.userApplyList.push(arr[i]);
            }
          }
          that.allApplyList = JSON.parse(JSON.stringify(that.userApplyList));
        })
        .catch((res) => {
          console.log("fail", res);
        });
    },
    switchStatus() {
      let that = this;
      that.userApplyList = [];
      that.currentPage = 1;
      that.total = 0;
      that.tableKey++;
      if (that.checkRadio == 1) that.getCustomerHistory(1);
      else if (that.checkRadio == 2) that.getCustomerHistory(2);
      else that.queryUpdateConfirm();
    },
    getCustomerHistory(index) {
      let that = this;
      that.userApplyList = [];
      let status;
      if (index == 1) status = "REFUSE";
      else if (index == 2) status = "PASS";
      that.$axios
        .post(that.$url_prefix + "track/customer/history", {
          page: that.currentPage,
          pageSize: that.pageSize,
          type: status,
        })
        .then(function (res) {
          console.log("返回", res);
          let arr = res.data.data.result;
          if (arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
              if (arr[i].key_word !== "latest_news" && arr[i].check_details) {
                arr[i].check_details = JSON.parse(arr[i].check_details);
              }
              if (arr[i].real_estate_id) {
                that.realApplyList.push(arr[i]);
              } else {
                that.userApplyList.push(arr[i]);
              }
            }
          }
          that.total = res.data.data.total;
        })
        .catch(function (res) {
          console.log("失败", res);
        });
    },
    dealGroupApply(check_status) {
      let that = this;
      that.$axios
        .post(that.$url_prefix + "dealGroupApply", {
          check_id: that.currentCheck.id,
          check_status: check_status,
        })
        .then(function (res) {
          console.log("返回", res);
          if (!res.data.success) {
            that.$message({
              message: "审核失败",
              type: "warning",
            });
            return false;
          }
          that.$message({
            message: "审核成功",
            type: "success",
          });
          that.currentCheck = {};
        })
        .catch(function (res) {
          console.log("失败", res);
          that.$message.error("上传失败");
        });
    },
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getCustomerHistory(this.checkRadio);
    },
    dealCreateApply(check_status) {
      let that = this;
      if (check_status == "REFUSE" && that.refuse_reason.length === 0) {
        that.$message({
          message: "请填写温馨提示",
          type: "warning",
        });
        return false;
      }
      that.$axios
        .post(that.$url_prefix + "dealCreateApply", {
          check_id: that.currentCheck.id,
          check_status: check_status,
          refuse_reason: that.refuse_reason,
        })
        .then(function (res) {
          console.log("返回", res);
          if (!res.data.success) {
            that.$message({
              message: "审核失败",
              type: "warning",
            });
            return false;
          }
          that.$message({
            message: "审核成功",
            type: "success",
          });
          that.currentCheck = {};
        })
        .catch(function (res) {
          console.log("失败", res);
          that.$message.error("上传失败");
        });
    },

    dealxsApply(check_status) {
      let that = this;
      if (check_status == "REFUSE" && that.refuse_reason.length === 0) {
        that.$message({
          message: "请填写温馨提示",
          type: "warning",
        });
        return false;
      }
      that.$axios
        .post(that.$url_prefix + "dealxsApply", {
          check_id: that.currentCheck.id,
          check_status: check_status,
          refuse_reason: that.refuse_reason,
        })
        .then(function (res) {
          console.log("返回", res);
          if (!res.data.success) {
            that.$message({
              message: "审核失败",
              type: "warning",
            });
            return false;
          }
          that.$message({
            message: "审核成功",
            type: "success",
          });
          that.currentCheck = {};
        })
        .catch(function (res) {
          console.log("失败", res);
          that.$message.error("上传失败");
        });
    },

    changeWay() {
      let that = this;
      if (that.jubao === "全部") {
        that.userApplyList = that.allApplyList;
      } else if (that.jubao === "举报用户") {
        that.userApplyList = that.allApplyList.filter((x) => {
          return x.report_type === "用户";
        });
      } else {
        that.userApplyList = that.allApplyList.filter((x) => {
          return x.report_type !== "用户";
        });
      }
    },

    dealApply(check_status) {
      let that = this;
      if (check_status == "REFUSE" && that.refuse_reason.length === 0) {
        that.$message({
          message: "请填写温馨提示",
          type: "warning",
        });
        return false;
      }
      that.$axios
        .post(that.$url_prefix + "dealApply", {
          check_id: that.currentCheck.id,
          check_status: check_status,
          refuse_reason: that.refuse_reason,
        })
        .then(function (res) {
          console.log("返回", res);
          if (!res.data.success) {
            that.$message({
              message: "审核失败",
              type: "warning",
            });
            return false;
          }
          that.$message({
            message: "审核成功",
            type: "success",
            duration: 1000,
          });
          that.currentCheck = {};
          that.userApplyList.splice(that.clickIndex, 1)[0]; //删除审核完的
          if (that.clickIndex < that.userApplyList.length) {
            //审核完成跳转下一条
            that.toCheck(that.clickIndex);
          } else if (that.userApplyList.length === 0) {
            return;
          } else {
            that.toCheck(0);
          }
        })
        .catch(function (res) {
          console.log("失败", res);
          that.$message.error("上传失败");
        });
    },

    dealNZ(check_status) {
      let that = this;
      if (check_status == "REFUSE" && that.refuse_reason.length === 0) {
        that.$message({
          message: "请填写温馨提示",
          type: "warning",
        });
        return false;
      }
      that.$axios
        .post(that.$url_prefix + "dealNZ", {
          check_id: that.currentCheck.id,
          check_details: that.currentCheck.check_details,
          check_status: check_status,
          refuse_reason: that.refuse_reason,
        })
        .then(function (res) {
          console.log("返回", res);
          if (!res.data.success) {
            that.$message({
              message: res.data.msg || "审核失败",
              type: "warning",
            });
            return false;
          }
          that.$message({
            message: "审核成功",
            type: "success",
          });
          that.$axios
            .post(that.$url_prefix + "sendTemplateMessage", {
              user_id: that.currentCheck.user_id,
              message_type: check_status == "PASS" ? "nzPass" : "nzRefuse",
              refuse_reason: that.refuse_reason,
            })
            .then(function (res) {
              console.log("发送通知返回", res);
            })
            .catch(function (res) {
              console.log("发送通知失败", res);
            });
          that.currentCheck = {};
        })
        .catch(function (res) {
          console.log("失败", res);
          that.$message.error("上传失败");
        });
    },

    toCheck(index) {
      let that = this;
      let item = "";
      if (that.queryType === "聊天举报") {
        item = that.userApplyList.splice(index, 1)[0];
      } else if (that.queryType === "业主群审核") {
        item = that.userApplyList.slice(index, index + 1)[0];
      } else {
        item = that.userApplyList.splice(index, 1)[0];
      }
      if (that.queryType === "APP反馈") {
        this.item = item;
        this.feedback = true;
      }
      if (
        item.check_details &&
        !["专家入驻", "业主群审核", "拿证审核"].includes(that.queryType) &&
        !that.queryType.includes("APP")
      ) {
        if (item.check_details.name && !item.check_details.user_name) {
          item.check_details.user_name = item.check_details.name;
        }
        let find = that.realEstateNameList.find((x) => {
          return x.real_estate_name === item.check_details.real_estates;
        });
        if (find) {
          that.noReal = false;
        } else {
          that.noReal = true;
        }
      }
      that.currentCheck = item;
      that.$previewRefresh();
    },

    // 专家
    expert() {
      let that = this;
      if (that.refuse_reason.length === 0) {
        that.$message({
          message: "请填写温馨提示",
          type: "warning",
        });
        return false;
      }
      let obj = {
        id: that.currentCheck.user_id,
        user_name: that.currentCheck.check_details.user_name,
        user_type: "专家",
        phone: that.currentCheck.check_details.phone,
        idCard: that.currentCheck.check_details.idCard,

        idCard2: that.currentCheck.check_details.idCard2,
        Sub_QR: that.currentCheck.check_details.Sub_QR,
        Tiktok_QR: that.currentCheck.check_details.Tiktok_QR,
        Group_QR: that.currentCheck.check_details.Group_QR,
        Sub_name: that.currentCheck.check_details.Sub_name,
        Tiktok_Num: that.currentCheck.check_details.Tiktok_Num,
        Group_Name: that.currentCheck.check_details.Group_Name,
        describe: that.currentCheck.check_details.describe,
        field: that.currentCheck.check_details.field,
        district: that.currentCheck.check_details.district,
        message: that.refuse_reason,
      };
      console.log("obj", obj, that.queryType);
      let modelMap = {
        杭州: "WpUserModel",
        苏州: "SzUserModel",
        天津: "TjUserModel",
        绍兴: "SxUserModel",
        宁波: "NbUserModel",
      };
      let param = {
        db: modelMap[that.city],
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log("更新用户返回", res);
          that.addPass();
          if (that.currentCheck.user_id) {
            that.$axios
              .get(that.$url_prefix + "expertChat", {
                params: {
                  user_id: that.currentCheck.user_id,
                },
              })
              .then(function (res) {
                console.log("建群成功", res);
              })
              .catch(function (res) {
                console.log("建群失败", res);
              });
          }
        })
        .catch(function (res) {
          console.log("上传用户失败", res);
          that.$message.error("上传失败");
        });
    },

    pass(from, userIndex) {
      console.log("pass");
      let that = this;
      if (from === "user") {
        that.passUser(userIndex);
      }
    },

    refuse(userIndex) {
      let that = this;
      if (
        that.queryType === "入驻审核" ||
        that.queryType === "中介审核" ||
        that.queryType === "头像审核"
      )
        that.currentCheck = that.userApplyList[userIndex];
      console.log(that.currentCheck);
      if (that.refuse_reason.length === 0) {
        that.$message({
          message: "请填写拒绝理由",
          type: "warning",
        });
        return false;
      }
      let obj = {
        id: that.currentCheck.id,
        check_status: "REFUSE",
        message: that.refuse_reason,
      };
      let param = {
        db: that.modelMap2[that.city],
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log(res);
          let type = "saleConfirmRefuse";
          if (that.queryType === "头像审核") {
            type = "headRefuse";
          } else if (that.queryType === "房源审核") {
            type = "hangRefuse";
          }
          that.$axios
            .post(that.$url_prefix + "sendTemplateMessage", {
              user_id: that.currentCheck.user_id,
              message_type: type,
              refuse_reason: that.refuse_reason,
            })
            .then(function (res) {
              console.log("发送通知返回", res);
              that.currentCheck = {};
              that.$message({
                message: "已拒绝",
                type: "success",
              });
            })
            .catch(function (res) {
              console.log("发送通知失败", res);
            });
        })
        .catch(function (res) {
          console.log(res);
        });
      // 入驻审核通过后展示删除通过项
      if (
        that.queryType === "入驻审核" ||
        that.queryType === "中介审核" ||
        that.queryType === "头像审核"
      )
        that.userApplyList.splice(userIndex, 1);
    },

    ignore(userIndex) {
      let that = this;
      if (
        that.queryType === "入驻审核" ||
        that.queryType === "中介审核" ||
        that.queryType === "头像审核"
      )
        that.currentCheck = that.userApplyList[userIndex];
      console.log(that.currentCheck);
      let obj = {
        id: that.currentCheck.id,
        check_status: "IGNORE",
        message: that.refuse_reason,
      };
      let param = {
        db: that.modelMap2[that.city],
        model: "edit",
        item: JSON.stringify(obj),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", param)
        .then(function (res) {
          console.log(res);
          that.currentCheck = {};
          that.$message({
            message: "已忽略",
            type: "success",
          });
        })
        .catch(function (res) {
          console.log(res);
        });
      // 入驻审核通过后展示删除通过项
      if (
        that.queryType === "入驻审核" ||
        that.queryType === "中介审核" ||
        that.queryType === "头像审核"
      )
        that.userApplyList.splice(userIndex, 1);
    },

    addPass() {
      let that = this;
      let updateModel = {
        id: that.currentCheck.id,
        check_status: "PASS",
      };
      let updateModelParam = {
        db: that.modelMap2[that.city],
        model: "edit",
        item: JSON.stringify(updateModel),
      };
      that.$axios
        .post(that.$url_prefix + "updateData", updateModelParam)
        .then(function (res) {
          console.log("更新pass成功", res);
          let type = "saleConfirmPass";
          if (that.queryType === "头像审核") {
            type = "headPass";
          } else if (that.queryType === "房源审核") {
            type = "hangPass";
          }
          that.$axios
            .post(that.$url_prefix + "sendTemplateMessage", {
              user_id: that.currentCheck.user_id,
              message_type: type,
              refuse_reason: that.refuse_reason,
            })
            .then(function (res) {
              console.log("发送通知返回", res);
              that.currentCheck = {};
              that.$message({
                message: "已通过",
                type: "success",
              });
              that.refuse_reason = "";
              that.userApplyList = [];
              that.queryUpdateConfirm();
            })
            .catch(function (res) {
              console.log("发送通知失败", res);
            });
        })
        .catch(function (res) {
          console.log("更新pass失败", res);
        });
    },

    passUser(userIndex) {
      let that = this;
      // console.log('queryType',that.queryType,userIndex);
      // console.log('user',that.userApplyList[userIndex]);
      // 入驻审核全展示
      if (
        that.queryType === "入驻审核" ||
        that.queryType === "中介审核" ||
        that.queryType === "头像审核"
      )
        that.currentCheck = that.userApplyList[userIndex];
      if (
        that.refuse_reason.length === 0 &&
        that.queryType !== "入驻审核" &&
        that.queryType !== "头像审核"
      ) {
        that.$message({
          message: "请填写温馨提示",
          type: "warning",
        });
        return false;
      }
      if (that.queryType === "入驻审核")
        that.refuse_reason = "欢迎入驻小鸡选房，祝您获客满满！";
      if (that.queryType === "头像审核")
        that.refuse_reason = "您提交的个人资料审核已通过！";
      let isMatch = that.realEstateNameList.find(
        (x) =>
          x.real_estate_name === that.currentCheck.check_details.real_estates
      );
      if (isMatch) {
        that.real_estate_id = isMatch.id;
      }
      if (!that.real_estate_id && that.queryType === "入驻审核") {
        that.$message({
          message: "没有匹配的楼盘",
          type: "warning",
        });
        return false;
      }
      that.$axios
        .get(that.$url_prefix + "queryUserInfo", {
          params: {
            user_id: that.currentCheck.user_id,
          },
        })
        .then(function (result) {
          console.log("查询user成功", result);
          let applicant = result.data.data; // 申请者
          let estates = applicant.estates || [];
          let estateList = that.currentCheck.check_details.estateList;
          if (estateList) {
            estates = estateList;
          }
          if (
            !applicant.user_type ||
            applicant.user_type !==
              (that.queryType === "中介审核" ? "经纪人" : "置业顾问")
          ) {
            estates = [];
          }
          if (estates.includes(that.real_estate_id)) {
            console.log("已经入驻过这个楼盘了");
          } else if (that.real_estate_id) {
            estates.push(that.real_estate_id);
          }
          let salehome = "2eyiyt7cqch";
          if (that.real_estate_id !== salehome) {
            estates = estates.filter((x) => x !== salehome);
          }
          let modelMap = {
            杭州: "WpRealEstateModel",
            苏州: "SzEstateModel",
            天津: "TjEstateModel",
            绍兴: "SxEstateModel",
            宁波: "NbEstateModel",
          };
          that.$axios
            .get(that.$url_prefix + "queryOneById", {
              params: {
                id: that.real_estate_id,
                db: modelMap[that.city],
              },
            })
            .then(function (res) {
              console.log("查询楼盘返回", res);
              if (!res.data.success && that.queryType === "入驻审核") {
                that.$message({
                  message: "没有匹配的楼盘",
                  type: "warning",
                });
                return false;
              }
              //有楼盘id，更新用户信息
              let obj = {
                id: that.currentCheck.user_id,
                user_name: that.currentCheck.check_details.user_name,
                user_type:
                  that.queryType === "中介审核" ? "经纪人" : "置业顾问",
                phone: that.currentCheck.check_details.phone,
                idCard: that.currentCheck.check_details.idCard,
                idCard2: that.currentCheck.check_details.idCard2 || "",
                card: that.currentCheck.check_details.card,
                lnglat: that.currentCheck.check_details.lnglat,
                congye_QR: that.currentCheck.check_details.congye_QR,
                weChat_QR: that.currentCheck.check_details.weChat_QR,
                weChat_num: that.currentCheck.check_details.weChat_num,
                setupName: that.currentCheck.check_details.setupName || "",
                employee_num:
                  that.currentCheck.check_details.employee_num || "",
                estates: estates,
                describe: that.currentCheck.check_details.describe || "",
                field: that.currentCheck.check_details.field || {},
              };
              if (that.currentCheck.check_details.avatar) {
                obj.head_url = that.currentCheck.check_details.avatar;
              }
              if (that.queryType === "头像审核") {
                obj = that.currentCheck.check_details;
                obj.id = that.currentCheck.user_id;
                obj.message = that.refuse_reason;
              }
              console.log("obj", obj, that.queryType);
              if (!applicant.join_date) {
                let today = new Date();
                let year = today.getFullYear();
                let month = today.getMonth() + 1;
                let date = today.getDate();
                let str = year + "-";
                if (month < 10) {
                  str = str + "0" + month + "-";
                } else {
                  str = str + month + "-";
                }
                if (date < 10) {
                  str = str + "0" + date;
                } else {
                  str = str + date;
                }
                obj.join_date = str;
              }
              let modelMap = {
                杭州: "WpUserModel",
                苏州: "SzUserModel",
                天津: "TjUserModel",
                绍兴: "SxUserModel",
                宁波: "NbUserModel",
              };
              let param = {
                db: modelMap[that.city],
                model: "edit",
                item: JSON.stringify(obj),
              };
              that.$axios
                .post(that.$url_prefix + "updateData", param)
                .then(function (res) {
                  console.log("更新用户返回", res);
                  if (that.currentCheck.check_details.userID) {
                    if (!applicant.join_date) {
                      that.$axios
                        .get(that.$url_prefix + "addInviteScore", {
                          params: {
                            from_id: that.currentCheck.check_details.userID,
                            to_id: applicant.id,
                            user_type: obj.user_type,
                          },
                        })
                        .then(function (res) {
                          console.log("是邀请的新顾问", res);
                          that.addPass();
                        })
                        .catch(function (res) {
                          console.log("加分失败", res);
                        });
                    } else {
                      console.log("被邀请人是置业顾问");
                      that.addPass();
                    }
                  } else {
                    console.log("没有邀请人");
                    that.addPass();
                  }
                })
                .catch(function (res) {
                  console.log("上传用户失败", res);
                  that.$message.error("上传失败");
                });
            })
            .catch(function (res) {
              console.log("查询楼盘失败", res);
            });
        })
        .catch(function (res) {
          console.log("查询user失败", res);
        });
      // 入驻审核通过后展示删除通过项
      if (that.queryType === "入驻审核" || that.queryType === "中介审核")
        that.userApplyList.splice(userIndex, 1);
    },
    // 绑定房源
    addHang() {
      let that = this;
      if (that.refuse_reason.length === 0) {
        that.$message({
          message: "请填写温馨提示",
          type: "warning",
        });
        return false;
      }
      //有楼盘id，更新用户信息
      let obj = {
        estate_id: that.currentCheck.check_details.estate_id,
        name: that.currentCheck.check_details.name,
        number: that.currentCheck.check_details.number,
        hang_price: that.currentCheck.check_details.hang_price,
        purpose: that.currentCheck.check_details.purpose,
        layout: that.currentCheck.check_details.layout,
        square: that.currentCheck.check_details.square,
        trim: that.currentCheck.check_details.trim,
        floor: that.currentCheck.check_details.floor,
      };
      console.log("obj", obj, that.currentCheck.user_id);
      that.$axios
        .post(that.$url_prefix + "createHang", {
          data: obj,
          user_id: that.currentCheck.user_id,
        })
        .then(function (res) {
          console.log("返回", res);
          if (!res.data.success) {
            that.$message({
              message: "已有该房源",
              type: "warning",
            });
            return false;
          }
          that.addPass();
        })
        .catch(function (res) {
          console.log("失败", res);
          that.$message.error("上传失败");
        });
    },
    // 解禁 /拉黑
    unclock(status, to_user, name, ssid) {
      let that = this;
      that
        .$confirm("是否" + status + name, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "unStatus", {
              params: {
                id: to_user,
                status: status,
              },
            })
            .then(function (res) {
              console.log("返回", res);
              that.$message({
                type: "success",
                message: status + "成功",
              });
              if (ssid) {
                that.$axios
                  .get(that.$url_prefix + "shenhe", {
                    params: {
                      type: that.queryType,
                      id: ssid,
                    },
                  })
                  .then(function (res) {
                    console.log("shenhe返回", res);

                    that.currentCheck = "";
                  })
                  .catch(function (res) {
                    console.log("shenhe失败", res);
                  });
              }
            })
            .catch(function (res) {
              console.log("失败", res);
              that.$message.error(status + "失败");
            });
        })
        .catch((err) => {
          console.log("取消", err);
        });
    },
    // APP 解禁 /拉黑
    unAppclock(status, to_user, name) {
      let that = this;
      that
        .$confirm("是否" + status + name, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "unAppclock", {
              params: {
                id: to_user,
                status: status,
              },
            })
            .then(function (res) {
              console.log("返回", res);
              that.$message({
                type: "success",
                message: status + "成功",
              });
            })
            .catch(function (res) {
              console.log("失败", res);
              that.$message.error(status + "失败");
            });
        })
        .catch((err) => {
          console.log("取消", err);
        });
    },
    shenhe(id, status) {
      console.log(id);
      let that = this;
      let words = "是否标记该举报记录为已审核";
      if (status === "驳回") {
        words = "确定不让TA再申诉了吗？";
      }
      that
        .$confirm(words, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "shenhe", {
              params: {
                type: that.queryType,
                id: id,
                status: status,
              },
            })
            .then(function (res) {
              if (that.clickIndex < that.userApplyList.length) {
                //审核完成跳转下一条
                that.toCheck(that.clickIndex);
              } else {
                that.currentCheck = "";
              }
              console.log("返回", res);
              that.$message({
                type: "success",
                message: "标记成功",
              });
            })
            .catch(function (res) {
              console.log("失败", res);
              that.$message.error("标记失败");
            });
        })
        .catch((err) => {
          console.log("取消", err);
        });
    },

    onRealNameInput() {
      let that = this;
      let matchList = [];
      for (let i in that.realEstateNameList) {
        let name = that.realEstateNameList[i].real_estate_name;
        let flag = 0;
        for (
          let i = 0;
          i < that.currentCheck.check_details.real_estates.length;
          i++
        ) {
          if (
            name.indexOf(that.currentCheck.check_details.real_estates[i]) > -1
          ) {
            flag++;
          }
        }
        if (flag > 0) {
          that.realEstateNameList[i].flag = flag;
          matchList.push(that.realEstateNameList[i]);
        }
      }
      if (matchList.length > 0) {
        matchList.sort((a, b) => {
          return b.flag - a.flag;
        });
        that.matchList = matchList;
      } else {
        that.matchList = [];
      }
    },
    chooseRealName(index) {
      let that = this;
      console.log("click");
      that.currentCheck.check_details.real_estates =
        that.matchList[index].real_estate_name;
      that.real_estate_id = that.matchList[index].id;
      that.matchList = [];
    },
    onRealNameBlur() {
      let that = this;
      console.log("blur");
      that.matchList = [];
    },
    onRealNameFocus() {
      console.log("focus");
      let that = this;
      let matchList = [];
      for (let i in that.realEstateNameList) {
        let name = that.realEstateNameList[i].real_estate_name;
        let flag = 0;
        for (
          let i = 0;
          i < that.currentCheck.check_details.real_estates.length;
          i++
        ) {
          if (
            name.indexOf(that.currentCheck.check_details.real_estates[i]) > -1
          ) {
            flag++;
          }
        }
        if (flag > 0) {
          that.realEstateNameList[i].flag = flag;
          matchList.push(that.realEstateNameList[i]);
        }
      }
      if (matchList.length > 0) {
        matchList.sort((a, b) => {
          return b.flag - a.flag;
        });
        that.matchList = matchList;
      } else {
        that.matchList = [];
      }
    },
    setfeedback(state) {
      this.$axios
        .post(this.$url_prefix + "xinghao/feedback/check", {
          id: this.item.id,
          status: state,
          reply_words: this.reply_words,
        })
        .then((res) => {
          console.log("返回", res);
          this.$message({
            message: "审核成功",
            type: "success",
          });
          (this.feedback = false), (this.reply_words = "");
        })
        .catch((res) => {
          console.log("失败", res);
          this.$message.error("审核失败");
        });
    },

    punishUser(type, check) {
      let that = this;
      let params = {
        type: type,
        check_id: check._id,
      };
      if (type == "软隐藏") {
        params.talk_id = check.talk_id;
      }
      that
        .$confirm("是否" + type + check.report_name, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          that.$axios
            .get(that.$url_prefix + "punishUser", {
              params,
            })
            .then(function (res) {
              console.log("返回", res);
              that.$message({
                type: "success",
                message: type + "成功",
              });
            })
            .catch(function (res) {
              console.log("失败", res);
              that.$message.error(type + "失败");
            });
        })
        .catch((err) => {
          console.log("取消", err);
        });
    },
    setStyle({ row, column, rowIndex, columnIndex }) {
      let that = this;
      if (that.queryType == "头像审核") {
        if (columnIndex == 4) {
          //头像
          if (row.head_url_change) {
            return this.stylechange;
          }
        } else if (columnIndex == 5) {
          //电话
          if (row.phone_change) {
            return this.stylechange;
          }
        } else if (columnIndex == 6) {
          //微信号
          if (row.weChat_num_change) {
            return this.stylechange;
          }
        } else if (columnIndex == 7) {
          //微信二维码
          if (row.weChat_QR_change) {
            return this.stylechange;
          }
        } else if (columnIndex == 8) {
          //口号
          if (row.brief_change) {
            return this.stylechange;
          }
        } else if (columnIndex == 11) {
          //姓名
          if (row.user_name_change) {
            return this.stylechange;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.sale {
  text-align: center;
  overflow: hidden;
}

/* .list {
    width: 100%;
    margin: 50px 0;
    text-align: left;
    overflow: hidden;
  } */

img {
  height: 100px;
  width: 100px;
}

.item {
  line-height: 50px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  font-size: 22px;
  font-weight: 700;
  margin: 0 10px;
  display: inline-block;
  text-align: center;
}

.realAplly {
  background-color: rgb(187, 110, 110);
}

.userAplly {
  background-color: rgb(59, 53, 53);
}

.normal {
  margin: 10px 0;
}

.latest-news-content {
  width: 500px;
  text-align: left;
  margin: 0 auto;
}

.feedbackImage {
  width: 20%;
  height: 100%;
}
.check {
  margin-bottom: 200px;
}
.el-image {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/page/operateTeam/newHouse/consultantReview/sale.vue